import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { OnboardingContainer } from '../../components/onboarding';
import { onboardingStorage } from '../../services/Onboarding';

export const Onboarding: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // If accessed from profile menu with reset flag, or if current step is completion, reset to step 1
    const progress = onboardingStorage.getProgress();
    if (location.state?.reset || (progress && progress.currentStep === 'completion')) {
      onboardingStorage.setCurrentStep('welcome');
      onboardingStorage.clearPrefillFlag();
    }
    setIsReady(true);
  }, [location.state]);

  const handleComplete = () => {
    onboardingStorage.completeOnboarding();
    navigate('/social-feed');
  };

  // Wait for reset to complete before rendering
  if (!isReady) {
    return null;
  }

  return (
    <OnboardingContainer />
  );
};

